export * from './appointment-comments.interface';
export * from './appointment-scheduler.interface';
export * from './appointment-users.interface';
export * from './appointments.interface';
